import OutflowGrid from "@/components/OutflowGrid";

export default function StatutoryCorpus() {
  return (
    <OutflowGrid
      page="statutory"
      testId="outflows-statutory"
      kicker="Outflows"
      title="Statutory & Corpus"
      editRole="finance"
      description="Tax outflows, legal & land diligence, corpus fund payments per project, and admin expenses. Amounts in ₹ Lakhs."
    />
  );
}
